document.addEventListener('DOMContentLoaded', function () {
    // Wait for 2 seconds before executing the main script
    setTimeout(function () {
        const maxTotal = 10;
        let activeDropsSum = 0;

        // Get all containers with the class 'note_drops'
        const noteDropGroups = document.querySelectorAll('.note_drops');

        noteDropGroups.forEach(noteDrop => {
            // Select only <select> elements within the container
            const selectBoxes = Array.from(noteDrop.querySelectorAll('select.gpo-select'));

            // Function to extract numeric value from a string (e.g., "2 ml" -> 2)
            function getItemCount(text) {
                const match = text.match(/\d+/);
                return match ? parseInt(match[0]) : 0;
            }

            // Function to get the numeric value from a specific class
            function extractNumberFromClass(element, baseclass) {
                for (const className of element.classList) {
                    const match = className.match(new RegExp(`^${baseclass}(\\d+)$`));
                    if (match) {
                        return Number(match[1]);
                    }
                }
                return null; // Return null if no matching class found
            }

            // Attach change event listeners to each select box
            selectBoxes.forEach(selectBox => {
                selectBox.addEventListener('change', function () {
                    selectBox.classList.add('active');                  

                    // Get parent and grandparent elements
                    const parentElement = this.parentNode;
                    const grandparentElement = parentElement.parentNode;

                    // Extract numeric values from classes
                    let ItemCount = extractNumberFromClass(grandparentElement, 'note_drops_');
                    let SectionCount = extractNumberFromClass(grandparentElement, 'note_drops_section_');
                    const SectionclassName = `note_drops_section_${SectionCount}`;

                    // Get all elements in the current section
                    const Dropelements = document.querySelectorAll(`.${SectionclassName}`);
                    Dropelements.forEach((element) => {
                        const targetClass = Array.from(element.classList).find((cls) => cls.startsWith("note_drops_"));
                        if (targetClass) {
                            const classNumber = parseInt(targetClass.split("_").pop(), 10); // Get the number from the class
                            if (classNumber > ItemCount) {
                                element.style.display = "none"; // Hide the element

                                const classNameNote = `note_selection_${classNumber}`;
                                const classNameDivider = `divider_line_${classNumber}`;
                                const SectionClassName = `note_selection_section_${SectionCount}`;
                                const DividerClassName = `divider_line_section_${SectionCount}`;

                                // Hide corresponding note and divider elements
                                const elementNote = document.querySelector(`.${classNameNote}.${SectionClassName}`);
                                if (elementNote) elementNote.style.display = 'none';

                                const elementDivider = document.querySelector(`.${classNameDivider}.${DividerClassName}`);
                                if (elementDivider) elementDivider.style.display = 'none';

                                // Reset <select> box if it has the 'active' class
                                const selectBoxL = element.querySelector('select');
                                if (selectBoxL && selectBoxL.classList.contains("active")) {
                                    selectBoxL.classList.remove("active");
                                    selectBoxL.selectedIndex = 0; // Reset to default option
                                }
                            }
                        }
                    });

                    // Calculate active values sum for the current section
                    const selectBoxesSection = document.querySelectorAll(`.${SectionclassName} select`);
                    activeDropsSum = 0;
                    selectBoxesSection.forEach(selectBox => {
                        if (selectBox.classList.contains('active')) {
                            const selectedDropValue = getItemCount(selectBox.value);
                            activeDropsSum += parseFloat(selectedDropValue) || 0;
                        }
                    });

                    // Check if active values sum is within the max limit
                    if (activeDropsSum < maxTotal) {
                        const NextItemCount = parseInt(ItemCount) + 1;
                        if (NextItemCount !== null) {
                            // Construct class names for the next item
                            const className = `note_drops_${NextItemCount}`;
                            const className2 = `note_selection_${NextItemCount}`;
                            const className3 = `divider_line_${NextItemCount}`;
                            const className4 = `note_selection_section_${SectionCount}`;

                            const DropSectionClassNameNew = `note_drops_section_${SectionCount}`;
                            const NoteSectionClassNameNew = `note_selection_section_${SectionCount}`;
                            const DividerSectionClassNameNew = `divider_line_section_${SectionCount}`;

                            // Show the next set of elements based on class names
                            const element = document.querySelector(`.${className}.${DropSectionClassNameNew}`);
                            if (element) element.style.display = 'block';

                            const element2 = document.querySelector(`.${className2}.${NoteSectionClassNameNew}`);
                            if (element2) element2.style.display = 'block';

                            const element3 = document.querySelector(`.${className3}.${DividerSectionClassNameNew}`);
                            if (element3) element3.style.display = 'block';

                            const element4 = document.querySelector(`.${className4}`);
                            if (element4) element4.style.display = 'block';

                            // Enable specific values in the next select box based on remaining capacity
                            const remaining = maxTotal - activeDropsSum;
                            const valuesToEnable = [];
                            for (let i = 1; i <= remaining; i++) {
                                valuesToEnable.push(`${i} ml`);
                            }
                            const selectBoxNxt = element.querySelector('select');
                            for (let i = 0; i < selectBoxNxt.options.length; i++) {
                                const option = selectBoxNxt.options[i];
                                option.disabled = !valuesToEnable.includes(option.value);
                            }
                        } else {
                            console.log('Class not found or no numeric value present.');
                        }
                    } else {
                        //alert('Limit reached for this section');
                    }
                });
            });

            // Function to hide all but the first element of a given class
            function hideExceptFirst(className) {
                const elements = document.getElementsByClassName(className);
                for (let i = 1; i < elements.length; i++) {
                    elements[i].style.display = 'none'; // Hide all except the first element
                }
            }

            // Initial hiding of elements in specific sections
            ['note_selection_section_1', 'note_drops_section_1', 'note_selection_section_2', 'note_drops_section_2'].forEach(hideExceptFirst);

            document.querySelectorAll('.divider_line').forEach(divider => {
                divider.style.display = 'none';
            });
        });
    }, 2000);
});